var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',_vm._g(_vm._b({attrs:{"api-key":_vm.api_key,"id":_vm.element_id,"init":{
        plugins: 'lists link image paste help wordcount autoresize fullscreen code',
        toolbar: 'undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help | code',
        image_uploadtab: true,
        images_upload_handler: _vm.image_upload_handler,
        auto_focus: _vm.element_id,
        relative_urls: false,
        remove_script_host: false,
    }},on:{"onChange":_vm.emitText},model:{value:(_vm.active_content),callback:function ($$v) {_vm.active_content=$$v},expression:"active_content"}},'editor',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }